import type { OSVersion } from '../schema/OSVersion';

/**
 * Returns the iOS Version
 */
export const getIOSVersion = (): OSVersion => {
    let version: OSVersion = null;

    if (typeof window === 'undefined' || !window?.navigator) {
        return version;
    }

    if (/iP(hone|od|od touch|ad)/.test(window?.navigator?.platform)) {
        // If appVersion contains 'OS 13_7' then version = ['OS 13_7', '13', '7', '0']
        const versionList = window?.navigator?.appVersion.match(/OS (\d+)_?(\d+)_?(\d+)?/);
        version = {
            major: parseInt(versionList[1] || '0', 10),
            minor: parseInt(versionList[2] || '0', 10),
            patch: parseInt(versionList[3] || '0', 10),
        };
    }

    return version;
};
